var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"radius-token-page"}},[_c('h2',[_vm._v("Radius token")]),_c('div',{staticClass:"radius-samples"},_vm._l((_vm.borderRadii),function(radius,name){return _c('div',{key:name,staticClass:"item-radius",class:name},[_vm._v("\n      "+_vm._s(radius)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }